import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { ShouldRender } from '../../../../ui-core/ShouldRender';
import {
  IMAGE_CONSTANT,
  // LOCAL_STORAGE_CONSTANT,
  MODAL_TYPE,
  TEXT_CONSTANT,
  TOUR_TARGET_ELEMENT,
} from '../../../../constants/app';
import { APP_ROUTES } from '../../../../route';
// import { extractJSON } from '../../../../services/jsonUtil';

import './style.css';
import useWindowWidth from '../../../../hooks/useWindowWidth';
import { getDisplayType } from '../../../../utils/helpers';
import HamburgerMenu from '../../../../components/HamburgerMenu';
import { Nav, Navbar } from 'react-bootstrap';

const Header = props => {
  // const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  // const buttonTitle = user ? TEXT_CONSTANT.JOIN_NOW : TEXT_CONSTANT.LOGIN;
  const buttonTitle = TEXT_CONSTANT.LOGIN;
  const handleRedirection = () => props.history.push(APP_ROUTES.ROOT);
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  return (
    <Navbar
      id="header-section"
      bg=""
      expand="lg"
      className="bg-white jen-navbar w-100"
    >
      <div className="header-wrapper d-flex justify-content-between px-lg-5 px-md-3 align-items-center w-100">
        {isMobileScreen && (
          <HamburgerMenu
            // blogClass={props.blogClass}
            // podcastClass={props.podcastClass}
            onFreeTrialClick={() => {
              props.onClick(
                TEXT_CONSTANT.GET_STARTED_FOR_FREE,
                'isSignup',
                'navigation header',
              );
            }}
            onLoginClick={() => {
              props.onClick('LOGIN', 'isLogin', 'navigation header');
            }}
          />
        )}
        <div className="d-flex">
          <h2 className="logo-text" onClick={handleRedirection}>
            Jen
          </h2>
          {!isMobileScreen && (
            <>
              {' '}
              <Nav.Link
                onClick={ev => {
                  ev.preventDefault();
                  props.history.push(APP_ROUTES.PODCASTS);
                }}
                data-tour-id={TOUR_TARGET_ELEMENT.podcast}
                className={`podcasts`}
              >
                <img alt="PodcastIcon" src={IMAGE_CONSTANT.MicMenu} />
                <span className="nav-text"> Podcasts</span>
              </Nav.Link>
              <Nav.Link
                onClick={ev => {
                  ev.preventDefault();
                  props.history.push(APP_ROUTES.BLOGS);
                }}
                data-tour-id={TOUR_TARGET_ELEMENT.blog}
                className={`blog`}
              >
                <img alt="BlogIcon" src={IMAGE_CONSTANT.NoteMenu} />
                <span className="nav-text px-2">Blogs</span>
              </Nav.Link>
            </>
          )}
        </div>

        <div>
          <ShouldRender check={props.showJoinNowBtn}>
            <button
              className="join border px-3"
              onClick={() =>
                props.onClick(
                  TEXT_CONSTANT.ENROLL_NOW,
                  'isLogin',
                  'navigation header',
                )
              }
            >
              {TEXT_CONSTANT.ENROLL_NOW}
            </button>
          </ShouldRender>
          <button
            className="join"
            onClick={() =>
              props.onClick(buttonTitle, MODAL_TYPE.LOGIN, 'Navigation Header')
            }
          >
            {buttonTitle}
          </button>
        </div>
      </div>
    </Navbar>
  );
};

Header.propTypes = {
  history: PropTypes.object,
  onClick: PropTypes.func,
  showJoinNowBtn: PropTypes.bool,
};

Header.defaultProps = {
  showJoinNowBtn: false,
};

export default withRouter(Header);
